<template>
  <el-dialog
    :visible.sync="visible"
    title="变更报修师傅"
    width="650px"
    custom-class="repair-master-dialog"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="86px" class="repair-master-form">
      <el-form-item label="选择师傅" prop="staffId">
        <div class="repair-master-picker">
          <el-input
            :value="form.staffName"
            readonly
            placeholder="请选择"
            class="repair-master-input"
            @focus="openStaffDialog"
          />
          <el-button class="repair-master-pick-btn" @click="openStaffDialog">选择</el-button>
        </div>
      </el-form-item>
      <el-form-item label="说明" prop="remark">
        <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入" maxlength="500" show-word-limit />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="repair-dialog-btn-cancel" @click="visible = false">取消</el-button>
      <el-button class="repair-dialog-btn-confirm" type="primary" @click="saveChanges">确定</el-button>
    </span>

    <el-dialog
      :visible.sync="staffDialogVisible"
      title="选择报修师傅"
      width="760px"
      custom-class="repair-staff-dialog"
      append-to-body
      @open="syncCurrentStaff"
    >
      <div class="repair-staff-toolbar">
        <el-input v-model="staffKeyword" clearable size="small" placeholder="请输入" class="repair-staff-search" />
      </div>
      <el-table
        ref="staffTable"
        v-loading="loading"
        :data="filteredStaffOptions"
        highlight-current-row
        row-key="userId"
        style="width: 100%"
        :header-cell-style="staffHeaderCellStyle"
        :cell-style="staffCellStyle"
        @row-click="selectStaffRow"
      >
        <el-table-column width="52">
          <template slot-scope="scope">
            <el-radio
              :value="pendingStaffId"
              :label="scope.row.userId"
              :disabled="disabledStaffIds.includes(String(scope.row.userId))"
              @change="selectStaffRow(scope.row)"
            >
              &nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="员工ID" min-width="150" show-overflow-tooltip />
        <el-table-column label="师傅名称" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatStaffName(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="tel" label="手机号" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.tel || '-' }}</template>
        </el-table-column>
        <el-table-column prop="orgName" label="组织" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orgName || '-' }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="repair-dialog-btn-cancel" @click="staffDialogVisible = false">取消</el-button>
        <el-button class="repair-dialog-btn-confirm" type="primary" @click="confirmStaffSelection">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getStaffInfos, listStaffCommunity, updateRepairTypeUser } from '@/api/work/repairTypeUserApi'

export default {
  name: 'EditRepairTypeUser',
  data() {
    return {
      visible: false,
      loading: false,
      staffDialogVisible: false,
      staffKeyword: '',
      staffOptions: [],
      disabledStaffIds: [],
      originalStaffId: '',
      pendingStaffId: '',
      communityId: '',
      form: this.getDefaultForm(),
      rules: {
        staffId: [{ required: true, message: '请选择员工', trigger: 'change' }]
      }
    }
  },
  computed: {
    filteredStaffOptions() {
      const keyword = this.staffKeyword.trim()
      if (!keyword) {
        return this.staffOptions
      }
      return this.staffOptions.filter(item => [item.userId, item.userName, item.name, item.tel, item.orgName]
        .some(value => String(value || '').includes(keyword)))
    }
  },
  methods: {
    getDefaultForm() {
      return {
        typeUserId: '',
        repairType: '',
        state: '',
        remark: '',
        staffId: '',
        staffName: ''
      }
    },

    open(repairTypeUser, boundStaffs = []) {
      this.originalStaffId = String(repairTypeUser.staffId || '')
      this.communityId = repairTypeUser.communityId || ''
      this.disabledStaffIds = boundStaffs
        .map(item => String(item.staffId))
        .filter(staffId => staffId && staffId !== this.originalStaffId)
      this.form = {
        typeUserId: repairTypeUser.typeUserId,
        repairType: repairTypeUser.repairType,
        state: repairTypeUser.state || '9999',
        remark: repairTypeUser.remark || '',
        staffId: repairTypeUser.staffId || '',
        staffName: repairTypeUser.staffName || ''
      }
      this.visible = true
      this.loadStaffOptions()
    },

    handleClose() {
      this.visible = false
      this.loading = false
      this.staffOptions = []
      this.disabledStaffIds = []
      this.originalStaffId = ''
      this.pendingStaffId = ''
      this.communityId = ''
      this.staffKeyword = ''
      this.staffDialogVisible = false
      this.form = this.getDefaultForm()
      this.$refs.form && this.$refs.form.clearValidate()
    },

    async loadStaffOptions() {
      this.loading = true
      try {
        const staffCommunityRes = await listStaffCommunity({
          page: 1,
          row: 1000,
          communityId: this.communityId,
          statusCd: '0'
        })
        const communityStaffs = staffCommunityRes.data || []
        const communityStaffIds = communityStaffs.map(item => String(item.staffId)).filter(Boolean)

        const { staffs } = await getStaffInfos({ page: 1, row: 1000 })
        const staffMap = new Map((staffs || []).map(item => [String(item.userId), item]))
        const sourceStaffs = communityStaffIds.length > 0
          ? communityStaffs.map(item => ({
            ...(staffMap.get(String(item.staffId)) || {}),
            ...item,
            userId: item.staffId,
            userName: item.staffName
          }))
          : (staffs || [])
        this.staffOptions = sourceStaffs.map(item => ({
          ...item,
          userId: item.userId,
          userName: item.userName || item.name
        }))
      } catch (error) {
        this.$message.error(error.message || '获取员工列表失败')
      } finally {
        this.loading = false
      }
    },

    formatStaffName(staff) {
      return staff.name || staff.userName || staff.userId
    },

    openStaffDialog() {
      this.staffDialogVisible = true
    },

    syncCurrentStaff() {
      this.pendingStaffId = this.form.staffId
      this.$nextTick(() => {
        if (!this.$refs.staffTable) {
          return
        }
        const currentStaff = this.staffOptions.find(item => String(item.userId) === String(this.pendingStaffId))
        if (currentStaff) {
          this.$refs.staffTable.setCurrentRow(currentStaff)
        }
      })
    },

    selectStaffRow(row) {
      if (this.disabledStaffIds.includes(String(row.userId))) {
        return
      }
      this.pendingStaffId = row.userId
      this.$refs.staffTable && this.$refs.staffTable.setCurrentRow(row)
    },

    confirmStaffSelection() {
      const staff = this.staffOptions.find(item => String(item.userId) === String(this.pendingStaffId))
      if (!staff) {
        this.$message.warning('请选择报修师傅')
        return
      }
      this.form.staffId = staff.userId
      this.form.staffName = this.formatStaffName(staff)
      this.staffDialogVisible = false
      this.$refs.form && this.$refs.form.validateField('staffId')
    },

    staffHeaderCellStyle() {
      return { background: '#EBF2FA', color: '#364153', fontWeight: 500, height: '44px', padding: '0' }
    },

    staffCellStyle() {
      return { color: '#1D2129', height: '48px', padding: '0' }
    },

    saveChanges() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }

        try {
          const response = await updateRepairTypeUser({
            ...this.form
          })
          if (response.code === 0) {
            this.$message.success(this.$t('common.operationSuccess'))
            this.$emit('success')
            this.handleClose()
          } else {
            this.$message.error(response.msg || this.$t('common.saveFailed'))
          }
        } catch (error) {
          this.$message.error(error.message || this.$t('common.saveFailed'))
        }
      })
    }
  }
}
</script>

<style lang="scss">
.repair-master-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    height: 66px;
    padding: 0 24px;
    background: #ebf2fa;
    border-bottom: 1px solid #dce6f5;
    line-height: 66px;
  }

  .el-dialog__title {
    color: #1d2129;
    font-size: 16px;
    font-weight: 600;
  }

  .el-dialog__headerbtn {
    top: 22px;
    right: 24px;
  }

  .el-dialog__body {
    padding: 24px 24px 8px;
  }

  .el-dialog__footer {
    padding: 20px 24px 28px;
  }
}

.repair-master-form {
  .el-form-item {
    margin-bottom: 20px;
  }

  .el-form-item__label {
    color: #1d2129;
    font-size: 14px;
    font-weight: 500;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
    color: #fb2c36;
  }
}

.repair-master-picker {
  display: flex;
  width: 100%;
  gap: 12px;
}

.repair-master-input {
  flex: 1;

  .el-input__inner {
    height: 38px;
    border-color: #dce6f5;
    border-radius: 10px;
    cursor: pointer;
  }
}

.repair-master-pick-btn {
  width: 82px;
  height: 38px;
  border-color: #0e76ff;
  border-radius: 10px;
  color: #0e76ff;
  background: #fff;
}

.repair-dialog-btn-cancel,
.repair-dialog-btn-confirm {
  width: 98px;
  height: 38px;
  border-radius: 10px;
  font-size: 14px;
}

.repair-dialog-btn-cancel {
  border-color: #0e76ff;
  color: #0e76ff;
  background: #fff;
}

.repair-dialog-btn-confirm {
  border-color: #0e76ff;
  background: #0e76ff;
  color: #fff;
}

.repair-staff-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    height: 66px;
    padding: 0 24px;
    background: #ebf2fa;
    border-bottom: 1px solid #dce6f5;
    line-height: 66px;
  }

  .el-dialog__title {
    color: #1d2129;
    font-size: 16px;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 20px 24px 8px;
  }

  .el-dialog__footer {
    padding: 20px 24px 28px;
  }

  .el-table {
    border-radius: 8px;
    overflow: hidden;
  }
}

.repair-staff-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
}

.repair-staff-search {
  width: 220px;

  .el-input__inner {
    height: 38px;
    border-color: #dce6f5;
    border-radius: 10px;
  }
}
</style>
